export class DeleteFleetConfigurationRequest {
    fleetId?: string;
}